import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function NextStepCTA() {
  return (
    <section className="py-[70px] bg-gradient-to-br from-primary via-brand-primary to-secondary">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="ArrowRightIcon" size={20} variant="solid" className="text-white" />
            <span className="text-sm font-cta font-semibold text-white">Next Step in Process</span>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-white mb-6">
            Ready for Welding Excellence?
          </h2>
          
          <p className="text-lg lg:text-xl text-gray-100 mb-8 leading-relaxed">
            After precision fabrication, our certified welding processes ensure structural integrity and contamination-free assembly for your critical components.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/welding-excellence"
              className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-accent text-white rounded-md font-cta font-bold text-base hover:bg-accent/90 transition-all duration-base shadow-lg"
            >
              <span>Explore Welding Capabilities</span>
              <Icon name="ArrowRightIcon" size={20} variant="outline" />
            </Link>
            
            <Link
              href="/homepage"
              className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-md font-cta font-bold text-base hover:bg-white/20 transition-all duration-base"
            >
              <Icon name="DocumentTextIcon" size={20} variant="outline" />
              <span>Request Quote</span>
            </Link>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <Icon name="ShieldCheckIcon" size={32} variant="outline" className="text-accent mb-4 mx-auto" />
              <h3 className="text-lg font-headline font-bold text-white mb-2">Certified Processes</h3>
              <p className="text-sm text-gray-200">AWS & ASME certified welding procedures</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <Icon name="BeakerIcon" size={32} variant="outline" className="text-accent mb-4 mx-auto" />
              <h3 className="text-lg font-headline font-bold text-white mb-2">Contamination Control</h3>
              <p className="text-sm text-gray-200">Clean room welding for semiconductor applications</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <Icon name="DocumentCheckIcon" size={32} variant="outline" className="text-accent mb-4 mx-auto" />
              <h3 className="text-lg font-headline font-bold text-white mb-2">Full Traceability</h3>
              <p className="text-sm text-gray-200">Complete documentation and quality records</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}